<template>
	<div class="print-qr-codes-container">
		<ModalHeader :title="getString('print_with_us')" />
		<div class="wrapper-heading">
			<p class="heading-category">{{ getString('qr_code_table') }}</p>
			<p>{{ getString('ideal_for_shop') }}</p>
		</div>
		<div class="card-wrapper">
			<div class="card-container">
				<QrCodeDisplayCard :img="imgWood" :price="3" size="8,5x5,7cm" :material="getString('wood_pvc')" :type="getString('wood')" @click="contactUsPopup(getString('wood'))" />
			</div>
			<div class="card-container">
				<QrCodeDisplayCard :img="imgWoodXl2" :price="7" size="10x12cm" :material="getString('wood_forex')" :type="getString('wood_xl_2')" @click="contactUsPopup(getString('wood_xl_2'))" />
			</div>
			<div class="card-container">
				<QrCodeDisplayCard :img="imgAcrylic" :price="7" size="6,5x5,5x7cm" :material="getString('acrylic')" :type="getString('pyramid')" @click="contactUsPopup(getString('pyramid'))" />
			</div>
			<div class="card-container">
				<QrCodeDisplayCard :img="imgRoundedSquare2" :price="4.5" size="7,5x9cm" :material="getString('acrylic')" :type="getString('rounded_square_2')" @click="contactUsPopup(getString('rounded_square_2'))" />
			</div>
			<div class="card-container">
				<QrCodeDisplayCard :img="imgRoundedStiker1" :price="1.5" size="7,5x9cm" :material="getString('sticker')" :type="getString('rounded_sticker_1')" @click="contactUsPopup(getString('rounded_sticker_1'))" />
			</div>
		</div>
		<div class="wrapper-heading mt-20">
			<p class="heading-category">{{ getString('qr_code_wall') }}</p>
			<p>{{ getString('ideal_for_event') }}</p>
		</div>
		<div class="card-wrapper pb-10">
			<div class="card-container card-container-best">
				<QrCodeDisplayCard :label="getString('best_seller')" :img="imgForex5070" :price="39" size="50x70cm" :material="getString('forex')" :type="getString('forex_50_70')" @click="contactUsPopup(getString('forex_50_70'))" />
			</div>
		</div>
		<AppPopup
			ref="popupContactUs"
			:title="getString('request_qr_popup_title')"
			:buttons="[{text: getString('cancel'), negative: true}, {text: getString('continue'), callback: contactUsComplete}]">
			<div class="text-align-center">
				<p>{{ getString('request_qr_popup_body', [contactType]) }}</p>
				<div class="container-label-delivery">
					<div class="align-icon-text-popup">
						<img src="https://img.qromo.io/img/icon-shipping.svg"  alt="icon delivery">
						<p class="icon-text">{{ getString('delivery_label') }}</p>
					</div>
					<p class="text-small">{{ getString('delivery_info_popup') }}</p>
				</div>
			</div>
		</AppPopup>
	</div>
</template>

<script>
import {useLanguageStore, useNotificationStore, useScriptStore} from "@/shared/stores";
import {useRoomsStore, useUserStore} from "@/console-new/stores";
import AppRadioButtonGroup from "@/shared/components/AppRadioButtonGroup.vue";
import AppDropdown from "@/shared/components/AppDropdown.vue";
import AppButton from "@/shared/components/AppButton.vue";
import QrCodeDisplayCard from "@/console-new/components/config/qrcode/QrCodeDisplayCard.vue";
import AppPopup from "@/shared/components/AppPopup.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";

export default {
	components: {ModalHeader, AppPopup, QrCodeDisplayCard, AppButton, AppDropdown, AppRadioButtonGroup},
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let roomsStore = useRoomsStore();
		const notificationStore = useNotificationStore();
		const scriptStore = useScriptStore();
		return {getString: languageStore.getString, showNotification: notificationStore.showNotification, userStore, roomsStore, scriptStore}
	},
	name: "PrintQrCodes",
	data() {
		return {
			isDiy: false,
			loading: false,
			imgWood: "https://img.qromo.io/img/espositore-base-laterale-def-min.jpg",
			imgWoodXl2: "https://img.qromo.io/img/espositore-forex-legno-v-2-min.jpg",
			imgAcrylic: "https://img.qromo.io/img/espositore-v-2-min.jpg",
			imgForex5070: "https://qromomilan.s3.eu-south-1.amazonaws.com/img/espositore-50-70-min.jpg",
			imgRoundedSquare2: "https://img.qromo.io/img/espositore-acrilico-piatto-r-1.jpg",
			imgRoundedStiker1: "https://img.qromo.io/img/adesivo-m1-int-1.jpg",
			contactType: "",
		}
	},
	computed: {
		printableQrsNumber() {
			if(this.roomsStore.tables === null) {
				return 0;
			}
			return this.roomsStore.tables.length;
		},
		changesSaved() {
			if(this.roomsStore.roomsTables !== null) {
				for(let i in this.roomsStore.roomsTables) {
					for(let y in this.roomsStore.roomsTables[i].tables) {
						if(!this.roomsStore.roomsTables[i].tables[y].token) {
							return false;
						}
					}
				}
			}
			return true;
		}
	},
	methods: {
		contactUsPopup(type) {
			this.contactType = type;
			this.$refs.popupContactUs.toggleStatus();
		},
		contactUsComplete() {
			let self = this;
			this.$refs.popupContactUs.toggleStatus();
			this.roomsStore.requestQrPrint(this.contactType, this.printableQrsNumber, function (success) {
				if(success) {
					self.showNotification("you-will-be-contacted-soon");
				} else {
					self.showNotification("generic-error");
				}
			});
		},
	},

}
</script>

<style lang="scss" scoped>
.print-qr-codes-container {

	.container-status {
		margin-bottom: 10px;
		display: flex;
		justify-content: center;

		&.danger {
			margin-bottom: 0;

			p {
				color: $danger;
			}
		}
	}

	.container-download {
		display: flex;
		justify-content: center;
	}

	.card-wrapper {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;

		.card-container {
			width: calc(33.33% - 15px);
			display: flex;
			justify-content: center;
			margin-bottom: 10px;
			@media (max-width: 1080px) {
				width: calc(50% - 15px);
			}
			@media (max-width: 768px) {
				width: 100%;
			}
			&:hover {
				:deep(.container-image) {
					img {
						transform: scale(1.05);
					}
				}
				:deep(.container-card-display) {
					box-shadow: 0 3px 15px var(--color-box-shadow-3);
				}
			}
			&.card-container-best {
				.container-card-display {
					border: 1px solid var(--dark-purple);
					box-shadow: 0 3px 22px -6px rgb(143 76 254);
				}
			}
		}
	}

	.wrapper-heading {
		padding: 20px 50px 5px;
		margin-bottom: 20px;
		border-bottom:  1px solid var(--color-border-3);
		@media (max-width: 1440px) {
			padding: 20px 10px 5px;
		}
		.heading-category {
			font-size: 18px;
			font-weight: 600;
			color: var(--color-txt);
			margin-bottom: 10px;
		}
	}
}
.text-align-center {
	text-align: center;
	.align-icon-text-popup {
		display: flex;
		.icon-text {
			margin-left: 10px;
			font-weight: 600;
		}
	}
	.container-label-delivery {
		margin-top: 15px;
		padding: 10px 15px;
		background-color: $alpha_1;
		border-radius: 13px;
		box-shadow: inset 0 1px 3px var(--color-alpha-1);
		.text-small {
			font-size: 14px;
			line-height: 21px;
			text-align: left;
		}
	}
}
</style>